import { render, staticRenderFns } from "./BundleAfterForm.vue?vue&type=template&id=fa3a02f8&"
import script from "./BundleAfterForm.vue?vue&type=script&lang=js&"
export * from "./BundleAfterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports